// Helper fetch JSON utilisé par les controllers Stimulus.
// Centralise le CSRF token + Content-Type + parsing.
//
// Usage :
//   import { fetchJson } from "lib/fetch_json"
//   const data = await fetchJson(url, { method: "POST", body: { fixture_id: 1 } })

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

export async function fetchJson(url, { method = "GET", body = null, headers = {} } = {}) {
  const finalHeaders = {
    "Content-Type": "application/json",
    "X-CSRF-Token": csrfToken(),
    ...headers
  }

  const response = await fetch(url, {
    method,
    headers: finalHeaders,
    body: body == null ? null : JSON.stringify(body)
  })

  if (!response.ok) {
    const error = new Error(`fetch failed: ${response.status}`)
    error.status = response.status
    throw error
  }

  return response.json()
}
